import type { Presentation } from '../../types';
import { DeepLinkCta } from './DeepLinkCta';

interface Props {
  p: Extract<Presentation, { type: 'stats' }>;
}

export function StatsPresentation({ p }: Props) {
  return (
    <div className="presentation-card">
      <div className="presentation-title">📈 Key figures</div>
      <div className="stats-grid">
        {p.cards.map((card, i) => (
          <div key={i} className="stats-card">
            <div className="stats-card-label">{card.label}</div>
            <div className="stats-card-value">{card.value}</div>
            {card.sublabel && (
              <div className="stats-card-sublabel">{card.sublabel}</div>
            )}
            {card.delta && (
              <div className={`stats-card-delta stats-card-delta--${card.delta.direction}`}>
                {arrowFor(card.delta.direction)} {card.delta.text}
              </div>
            )}
          </div>
        ))}
      </div>
      {p.cta && <DeepLinkCta cta={p.cta} />}
    </div>
  );
}

function arrowFor(direction: 'up' | 'down' | 'flat'): string {
  if (direction === 'up') return '▲';
  if (direction === 'down') return '▼';
  return '–';
}
